var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.7 110.7",
    style: {
      enableBackground: "new 0 0 110.7 110.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#545554;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,55.3c0,19.3-15.6,35-34.9,35s-35-15.8-35-35.1c0-19.2,15.9-34.9,35-34.9C74.7,20.3,90.3,36,90.3,55.3z  M59.5,70.1c0-0.9,0-1.6,0-2.3c0-5.2,0-10.6,0-15.9c0-1.4-0.2-2.7-2-2.8c-2.6-0.1-5.2-0.1-7.8,0.1c-0.7,0.1-1.6,1.3-1.8,2 c-0.3,1.5,1.1,1.2,1.9,1.2c1.6-0.1,2,0.5,2,2c-0.1,4.3-0.1,8.8,0,13.2c0,1.9-0.2,3-2.4,2.7c-2.3-0.3-1.8,1.4-1.9,2.7 c-0.1,1.4,0,2.3,1.9,2.3c4-0.1,7.9,0,11.9,0c2.7,0,2.6,0,2.7-2.6c0.1-2-0.6-2.7-2.4-2.4C60.9,70.2,60.4,70.1,59.5,70.1z M55.1,45.4 c2.5,0,4.4-2,4.4-4.4c0-2.3-2.1-4.6-4.4-4.6c-2.6,0-4.6,2.1-4.6,4.7C50.6,43.5,52.5,45.4,55.1,45.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.27519d81e3301802f48a9f076e33ab39.svg";
export { ForwardRef as ReactComponent };